import React from "react";
import "./style.scss";
import SeggregationBatchList from "../../../components/Seggregation/SeggregationBatchList";
const SeggregrationBatchListPage = () => {
  return (
    <div className="seggregation_batch_list_page_wrapper">
      <SeggregationBatchList />
    </div>
  );
};
export default SeggregrationBatchListPage;
